import { render, staticRenderFns } from "./WarrantyAgreement.vue?vue&type=template&id=2fe848cd&scoped=true"
import script from "./WarrantyAgreement.vue?vue&type=script&lang=js"
export * from "./WarrantyAgreement.vue?vue&type=script&lang=js"
import style0 from "./WarrantyAgreement.vue?vue&type=style&index=0&id=2fe848cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe848cd",
  null
  
)

export default component.exports